import React from 'react';
import { Row, Col } from '../../../legacy/hui/src/styled/';
import { ButtonRemove } from '../Bunnings/Buttons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import tick from '../../images/extra-install-tick.svg';
import close from '../../images/extra-install-close.svg';
import getCategoryId from '../../selectors/categoryId';
import Categories from '../../constants/Categories';

const Wrapper = styled.div`
  div,
  a,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  button {
    font-family: roboto !important;
  }
`;
const InstallTitleText = Col.extend`
  min-width: 160px;
  width: 160px;
  font-size: 15px;
  font-weight: 600;
  padding-top: 10px;
  color: #434447;
  white-space: nowrap;
`;

const PurchaseTitleText = Col.extend`
  min-width: 120px;
  width: 120px;
  font-size: 15px;
  padding-top: 10px;
  font-weight: 600;
  color: #434447;
  white-space: nowrap;
`;

const InstallText = Col.extend`
  min-width: 160px;
  width: 160px;
  font-size: 13px;
  line-height: 18px;
  margin-top: 10px;
  color: #555659;
  white-space: nowrap;
`;

const PurchaseText = Col.extend`
  min-width: 120px;
  width: 120px;
  font-size: 13px;
  line-height: 18px;
  padding-top: 10px;
  color: #555659;
  white-space: nowrap;
`;

const OtherText = Col.extend`
  font-size: 13px;
  padding-top: 10px;
  line-height: 18px;
  color: #555659;
  white-space: nowrap;
`;

const TextWrapper = styled.div`
  height: 18px;
  display: flex;
  align-items: center;
`;

const TickLogo = styled.div`
  width: 16px;
  height: 16px;
  background: url(${tick}) no-repeat;
  text-indent: -99999px;
  display: inline-block;
  background-size: contain;
`;

const TickText = styled.div`
  padding-left: 5px;
  font-size: 13px;
  color: #71a643;
  margin-top: 2px;
`;

const ExtraInstallList = ({ extraList, removeExtraInstall }) => (
  <Wrapper>
    <Row>
      <InstallTitleText>Install Code</InstallTitleText>
      <PurchaseTitleText>Purchase Date</PurchaseTitleText>
    </Row>
    {extraList &&
      extraList.map((item, index) => {
        const cid = getCategoryId(item.categories);
        const category = Categories[cid].name;
        return (
          <Row key={index}>
            <InstallText>{item.voucher}</InstallText>
            <PurchaseText>{item.date}</PurchaseText>
            <OtherText>
              {item.canRemove && (
                <TextWrapper>
                  <TickLogo />
                  <TickText>{category} added to install</TickText>
                  <ButtonRemove muted onClick={() => removeExtraInstall(item.voucher, item.date)}>
                    <div style={{ position: 'relative' }}>
                      {'Remove'}
                      <img src={close} style={{ position: 'absolute', top: 0, marginLeft: 3 }} />
                    </div>
                  </ButtonRemove>
                </TextWrapper>
              )}
            </OtherText>
          </Row>
        );
      })}
  </Wrapper>
);

ExtraInstallList.propTypes = {
  extraList: PropTypes.array,
  removeExtraInstall: PropTypes.func
};

export default ExtraInstallList;
